<template>
  <a-card :bordered='false'>
    <a-button class="m-b-20" type="primary" v-has:GroupPurchaseAdd="()=>{$router.push('/guide/GroupPurchase/group_create?type=add')}">
      <PlusOutlined />
      创建团购任务
    </a-button>
    <a-form ref='form' :model='search' class="m-b-20" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="关键词" name='keyword'>
        <a-input v-model:value="search.keyword" style="width:250px" placeholder="请输入任务ID/任务标题" />
      </a-form-item>
      <a-form-item label="状态" name='status'>
        <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">启用</a-select-option>
          <a-select-option :value="0">禁用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChangeTime" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data' class='tableFixBox' :scroll="{ x: 'max-content'}">
      <template v-slot:status="{ record }">
        <p v-if="record.status==1">启用</p>
        <p v-else>禁用</p>
      </template>
      
      <template v-slot:action="{ record }">
        <a-dropdown>
          <a class="ant-dropdown-link"> 操作
            <DownOutlined />
          </a>
          <template v-slot:overlay>
            <a-menu>
              <a-menu-item>
                <a-button type="link" size="small" v-has:GroupPurchaseEdit="()=>{$router.push('/guide/GroupPurchase/group_Edit?type=edit&id='+record.id)}">编辑</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button type="link" size="small" v-has:GroupPurchaseDetail="()=>{$router.push('/guide/GroupPurchase/group_Detail?type=look&id='+record.id)}">详情</a-button>
              </a-menu-item>
              <a-menu-item v-if="record.status==1">
                <a-button  type="link" size="small" v-has:GroupPurchaseDisable="()=>disBtn(record)">禁用</a-button>
              </a-menu-item>
              <a-menu-item v-if="record.status==0">
                <a-button type="link" size="small" v-has:GroupPurchaseDisable="()=>disBtn(record)">启用</a-button>
              </a-menu-item>
              <a-menu-item>
                <a-button type="link" size="small" v-has:GroupPurchaseDel="()=>delBtn(record)">删除</a-button>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
import { DownOutlined, PlusOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import {
  getgrouptaskList,
  upgrouptaskstatus,
  delgrouptask
} from "@/api/guide";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  keyword: "",
  status: "",
  start_time: "",
  end_time: "",
};
export default {
  components: {
    DownOutlined,
    PlusOutlined,
  },
  setup() {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      questionnaire_id: "",
      listLoading: false,
      total: 0,
    });
    let columns = [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "任务标题",
        dataIndex: "name",
        key: "name",
        customRender: ({ record }) => {
          return record.name ? record.name : "-";
        },
      },
      {
        title: "状态",
        dataIndex: "status",
        key: "status",
        slots: { customRender: "status" },
      },
      {
        title: "创建时间",
        dataIndex: "create_time",
        key: "create_time",
      },
      {
        title: "操作",
        key: "action",
        width: 100,
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData();
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData();
    };
    //删除
    const delBtn = (e) => {
      $Modal.confirm({
        title: "提示",
        content: "删除后不可恢复且在渠道不可见，确定删除吗？",
        centered: true,
        onOk: async () => {
          let res = await delgrouptask({id:e.id})
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(res)) {
            message.success(res.message);
            initData();
          } else {
            message.error(res.message);
          }
        },
      });
    };
    //禁用
    const disBtn = (e) => {
      if (e.status == 1) {
        $Modal.confirm({
          title: "提示",
          content: "禁用后在渠道不可见，确定禁用吗？",
          centered: true,
          onOk: async () => {
            let res = await upgrouptaskstatus({id:e.id})
              .then((res) => res.data)
              .catch((error) => error);
            if (iscode(res)) {
              message.success(res.message);
              initData();
            } else {
              message.error(res.message);
            }
          },
        });
      } else {
        $Modal.confirm({
          title: "提示",
          content: "确定启用该任务吗？",
          centered: true,
          onOk: async () => {
            let res = await  upgrouptaskstatus({id:e.id})
              .then((res) => res.data)
              .catch((error) => error);
            if (iscode(res)) {
              message.success(res.message);
              initData();
            } else {
              message.error(res.message);
            }
          },
        });
      }
    };

    const onChangeTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData();
    };
    const initData = async () => {
      state.listLoading = true;
      let res = await getgrouptaskList({ ...search.value })
        .then((res) => res.data)
        .catch((error) => error);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data.data;
        state.total = res.data.total;
      } else {
        message.error(res.message);
      }
    };
    onMounted(() => {
      initData();
    });
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      delBtn,
      initData,
      onChangeTime,
      disBtn,
    };
  },
};
</script>
<style>
.ant-table td {
  white-space: nowrap;
}
</style>